export default __webpack_public_path__ + "static/media/Vigdis Soothsayer's Ring.34e784ec.jpg";